<form [formGroup]="installCertificateForm" (ngSubmit)="handleOnSubmit()" #formRef="ngForm">
  <h2 mat-dialog-title>{{ 'INSTALL_CERTIFICATE' | translate }}</h2>

  <mat-dialog-content>
    <div class="mb-4">
      <mat-button-toggle-group formControlName="method">
        <mat-button-toggle value="certificate">
          {{ 'INSTALL_CERTIFICATE_FROM_TEXT' | translate }}
        </mat-button-toggle>
        <mat-button-toggle value="file">
          {{ 'INSTALL_CERTIFICATE_FROM_FILE' | translate }}
        </mat-button-toggle>
        <mat-button-toggle value="backend">
          {{ 'INSTALL_CERTIFICATE_FROM_BACKEND' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (method === 'backend') {
      <div class="input-row">
        <mat-form-field floatLabel="auto" class="w-full">
          <mat-label>{{ 'CERTIFICATE_ALGORITHM' | translate }}</mat-label>
          <mat-select formControlName="algorithm">
            @for (algorithm of certificateAlgorithms; track algorithm) {
              <mat-option [value]="algorithm">{{ algorithm }}</mat-option>
            }
          </mat-select>
          <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    }

    @if (method === 'certificate') {
      <div class="input-row">
        <mat-form-field class="w-full">
          <mat-label>{{ 'SIGNING_CERTIFICATE' | translate }}</mat-label>
          <textarea matInput rows="6" formControlName="certificate"></textarea>
          <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    }

    @if (method === 'file') {
      <div class="input-row mb-2">
        <input type="file" (change)="handleFile($event)" class="hidden" #fileUpload accept=".pem,.crt,.cer,.txt" />
        <button mat-stroked-button (click)="fileUpload.click()" type="button">
          <mat-icon>upload_file</mat-icon>
          <span [class.text-red-400]="formRef.submitted && !fileToUpload">
            {{ 'UPLOAD_CERTIFICATE_FILE' | translate }}
          </span>
        </button>
        @if (fileToUpload) {
          <p class="!mt-0">{{ fileToUpload.name }}</p>
        }
        @if (formRef.submitted && !fileToUpload) {
          <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
        }
      </div>
    }

    @if (method === 'certificate' || method === 'file') {
      <div class="input-row">
        <mat-form-field floatLabel="auto" class="w-full">
          <mat-label>{{ 'CERTIFICATE_TYPE' | translate }}</mat-label>
          <mat-select formControlName="certificateType">
            @for (type of installCertificateTypes; track type) {
              <mat-option [value]="type">{{ type }}</mat-option>
            }
          </mat-select>
          <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ 'OK' | translate }}
    </button>
    <button mat-raised-button (click)="close()" type="button">
      {{ 'CANCEL' | translate }}
    </button>
  </mat-dialog-actions>
</form>
